import React from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { useAuth, useProfile } from '../../contexts/AuthContext';
import { ShowImage } from '../utils/image';
import { useTabManager } from '../../contexts/tab-manager';

const TopBar = ({ side = false, setSide = () => { } }) => {
    const authProv = useAuth();
    const profile = useProfile();
    let navigate = useNavigate();
    const tabManager = useTabManager();

    const logOut = () => {
        authProv.signout(() => {
            navigate("sign-in");
        });
    } //clearing the context

    const toggleSide = () => {
        setSide(!side);
    }

    const openProfile = (e) => {
        e.preventDefault();
        tabManager.open({ title: `${profile.fname} ${profile.lname}`, url: `${process.env.PUBLIC_URL}/profile/${profile.id}` });
    }

    return (
        <nav className="navbar navbar-light navbar-expand bg-white shadow topbar static-top">
            <div className="container-fluid">
                <button onClick={toggleSide} className="btn btn-link d-md-none rounded-circle me-3" id="sidebarToggleTop" type="button"><i className="fas fa-bars"></i></button>
                {/* <form className="d-none d-sm-inline-block me-auto ms-md-3 my-2 my-md-0 mw-100 navbar-search">
                    <div className="input-group">
                        <input type="text" className="bg-light form-control border-0 small" placeholder="Search for ..." />
                        <button className="btn btn-primary py-0" type="button">
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                </form> */}
                <ul className="navbar-nav flex-nowrap ms-auto">
                    {/* <li className="nav-item dropdown d-sm-none no-arrow">
                        <a aria-expanded="false" data-bs-toggle="dropdown" className="dropdown-toggle nav-link" href="./">
                            <i className="fas fa-search"></i>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end p-3 animated--grow-in" aria-labelledby="searchDropdown">
                            <form className="me-auto navbar-search w-100">
                                <div className="input-group">
                                    <input type="text" className="bg-light form-control border-0 small" placeholder="Search for ..." />
                                    <div className="input-group-append">
                                        <button className="btn btn-primary py-0" type="button">
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </li>
                    <li className="nav-item dropdown no-arrow mx-1">
                        <div className="nav-item dropdown no-arrow"><a aria-expanded="false" data-bs-toggle="dropdown" className="dropdown-toggle nav-link" href="./"><span className="badge bg-danger badge-counter">3+</span><i className="fas fa-bell fa-fw"></i></a>
                            <div className="dropdown-menu dropdown-menu-end dropdown-list animated--grow-in">
                                <h6 className="dropdown-header">alerts center</h6>
                                <a className="dropdown-item d-flex align-items-center" href="./">
                                    <div className="me-3">
                                        <div className="bg-primary icon-circle"><i className="fas fa-file-alt text-white"></i></div>
                                    </div>
                                    <div>
                                        <span className="small text-gray-500">December 12, 2019</span>
                                        <p>A new monthly report is ready to download!</p>
                                    </div>
                                </a>
                                <a className="dropdown-item d-flex align-items-center" href="./">
                                    <div className="me-3">
                                        <div className="bg-success icon-circle"><i className="fas fa-donate text-white"></i></div>
                                    </div>
                                    <div><span className="small text-gray-500">December 7, 2019</span>
                                        <p>$290.29 has been deposited into your account!</p>
                                    </div>
                                </a>
                                <a className="dropdown-item d-flex align-items-center" href="./">
                                    <div className="me-3">
                                        <div className="bg-warning icon-circle"><i className="fas fa-exclamation-triangle text-white"></i></div>
                                    </div>
                                    <div><span className="small text-gray-500">December 2, 2019</span>
                                        <p>Spending Alert: We&#39;ve noticed unusually high spending for your account.</p>
                                    </div>
                                </a>
                                <a className="dropdown-item text-center small text-gray-500" href="./">Show All Alerts</a>
                            </div>
                        </div>
                    </li> */}
                    {/* <li className="nav-item dropdown no-arrow mx-1">
                        <div className="nav-item dropdown no-arrow">
                            <a aria-expanded="false" data-bs-toggle="dropdown" className="dropdown-toggle nav-link" href="./">
                                <span className="badge bg-danger badge-counter">7</span><i className="fas fa-envelope fa-fw"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end dropdown-list animated--grow-in">
                                <h6 className="dropdown-header">alerts center</h6>
                                <a className="dropdown-item d-flex align-items-center" href="./">
                                    <div className="dropdown-list-image me-3">
                                        <img className="rounded-circle" src="avatars/avatar4.jpeg" />
                                        <div className="bg-success status-indicator"></div>
                                    </div>
                                    <div className="fw-bold">
                                        <div className="text-truncate">
                                            <span>Hi there! I am wondering if you can help me with a problem I&#39;ve been having.</span>
                                        </div>
                                        <p className="small text-gray-500 mb-0">Emily Fowler - 58m</p>
                                    </div>
                                </a><a className="dropdown-item d-flex align-items-center" href="./">
                                    <div className="dropdown-list-image me-3">
                                        <img className="rounded-circle" src="avatars/avatar2.jpeg" />
                                        <div className="status-indicator"></div>
                                    </div>
                                    <div className="fw-bold">
                                        <div className="text-truncate">
                                            <span>I have the photos that you ordered last month!</span>
                                        </div>
                                        <p className="small text-gray-500 mb-0">Jae Chun - 1d</p>
                                    </div>
                                </a><a className="dropdown-item d-flex align-items-center" href="./">
                                    <div className="dropdown-list-image me-3">
                                        <img className="rounded-circle" src="avatars/avatar3.jpeg" />
                                        <div className="bg-warning status-indicator"></div>
                                    </div>
                                    <div className="fw-bold">
                                        <div className="text-truncate">
                                            <span>Last month&#39;s report looks great, I am very happy with the progress so far, keep up the good work!</span>
                                        </div>
                                        <p className="small text-gray-500 mb-0">Morgan Alvarez - 2d</p>
                                    </div>
                                </a><a className="dropdown-item d-flex align-items-center" href="./">
                                    <div className="dropdown-list-image me-3">
                                        <img className="rounded-circle" src="avatars/avatar5.jpeg" />
                                        <div className="bg-success status-indicator"></div>
                                    </div>
                                    <div className="fw-bold">
                                        <div className="text-truncate">
                                            <span>Am I a good boy? The reason I ask is because someone told me that people say this to all dogs, even if they aren&#39;t good...</span>
                                        </div>
                                        <p className="small text-gray-500 mb-0">Chicken the Dog · 2w</p>
                                    </div>
                                </a>
                                <a className="dropdown-item text-center small text-gray-500" href="./">Show All Alerts</a>
                            </div>
                        </div>
                        <div className="shadow dropdown-list dropdown-menu dropdown-menu-end" aria-labelledby="alertsDropdown"></div>
                    </li> */}
                    <div className="d-none d-sm-block topbar-divider"></div>
                    <Nav>
                        <NavDropdown className="no-arrow" title={
                            <>
                                <span className="d-none d-lg-inline me-2 text-gray-600 small">{profile?.fname} {profile?.lname}</span>
                                <ShowImage src={profile?.photo} className='border rounded-circle img-profile' alt={`${profile?.fname} ${profile?.lname}`} />
                            </>
                        } >
                            <NavDropdown.Item onClick={openProfile}>
                                <i className="fas fa-user fa-sm fa-fw me-2 text-gray-400"></i> Profile
                            </NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item onClick={logOut}>
                                <i className="fas fa-sign-out-alt fa-sm fa-fw me-2 text-gray-400"></i>Logout
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                    {/* <li className="nav-item dropdown no-arrow">
                        <div className="nav-item dropdown no-arrow">
                            <div aria-expanded="false" data-bs-toggle="dropdown" className="dropdown-toggle nav-link">
                                <span className="d-none d-lg-inline me-2 text-gray-600 small">{profile?.fname ?? ""} {profile?.lname ?? ""}</span>
                                <img className="border rounded-circle img-profile" src="/user.png" alt="" />
                            </div>
                            <div className="dropdown-menu shadow dropdown-menu-end animated--grow-in">
                                <a className="dropdown-item" href="./">
                                    <i className="fas fa-user fa-sm fa-fw me-2 text-gray-400"></i> Profile
                                </a>
                                <a className="dropdown-item" href="./">
                                    <i className="fas fa-cogs fa-sm fa-fw me-2 text-gray-400"></i> Settings
                                </a>
                                <a className="dropdown-item" href="./">
                                    <i className="fas fa-list fa-sm fa-fw me-2 text-gray-400"></i> Activity log
                                </a>
                                <div className="dropdown-divider"></div>
                                <Button variant='link' className="dropdown-item" onClick={logOut}><i className="fas fa-sign-out-alt fa-sm fa-fw me-2 text-gray-400"></i> Logout</Button>
                            </div>
                        </div>
                    </li> */}
                </ul>
            </div>
        </nav>);
}

export default TopBar;